module.exports = __webpack_public_path__ + "static/media/circulo.390bb194.png";